type ApiValidationErrorResponse = {
	message?: string;
	errors: Record<string, string[]>;
};

export const isApiValidationErrorResponse = (value: unknown): value is ApiValidationErrorResponse => {
	if (typeof value !== 'object' || value === null || !('errors' in value)) {
		return false;
	}

	const errors = value.errors;

	if (typeof errors !== 'object' || errors === null) {
		return false;
	}

	return Object.values(errors).every(
		(messages) => Array.isArray(messages) && messages.every((message) => typeof message === 'string'),
	);
};

export default ApiValidationErrorResponse;
